import * as Yup from 'yup';
import { INTEGRATION_TYPE } from '~/src/utils/integrationsConstants';

export const validationSchema = Yup.object().shape({
  integrationName: Yup.string().required('Integration Name is required'),
  svilaClientId: Yup.string().required('Svila Client is required'),
  integrationType: Yup.number()
    .required('Integration Type is required')
    .test(
      'not-unknown',
      'Integration Type cannot be Unknown',
      value => value !== INTEGRATION_TYPE.UNKNOWN_TYPE.value
    ),
  apiUrl: Yup.string().required('API URL is required'),
  credentialsFields: Yup.object().test(
    'all-required',
    'All credentials fields are required',
    obj => obj && Object.values(obj).every(val => typeof val === 'string' ? val.trim() !== '' : false)
  ),
});